import React from "react";
import "../styles/style.css";
import "../styles/WoodsSite.css";
import HeaderSerene from "../components/HeaderSerene";
import HeroVillas from "../components/vessellavilla/HeroVillas";
import WoodsLogo from "../assets/images/woods-logo.avif";
import AboutWoods from "../components/vessellavilla/AboutWoods";
import AboutWoods1 from "../components/vessellavilla/AboutWoods1";
import Clubhouse from "../components/vessellavilla/ClubHouseWoods";
import WoodsMasterplan from "../components/vessellavilla/WoodsMasterplan";
import LocationWoods from "../components/vessellavilla/LocationWoods";
import WoodsSpecificationAccordion from "../components/vessellavilla/WoodsSpecificationAccordion";
import ContactWoods from "../components/vessellavilla/ContactWoods";
import ApprovedBanks from "../components/ApprovedBanks";

const menuLinks = [
  { label: "ABOUT WOODS", target: "about-serene" },
  { label: "AMENITIES", target: "woods-clubhouse" },
  { label: "MASTERPLAN", target: "woods-masterplay" },
  { label: "LOCATION", target: "woods-location" },
  { label: "SPECIFICATIONS", target: "serene-specifications" },
  { label: "CONTACT", target: "serene-contact" },
];

function VillasSite() {
  return (
    <section id="home-woods">
      <HeaderSerene logo={WoodsLogo} menuLinks={menuLinks} />
      <HeroVillas />
      <AboutWoods />
      <AboutWoods1 />
      <Clubhouse />
      <WoodsMasterplan />
      <LocationWoods />
      <WoodsSpecificationAccordion />
      <ApprovedBanks />
      <ContactWoods />
    </section>
  );
}

export default VillasSite;
